module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/upset-working-woman-c34332bc17dc47f395b3cd6e7adf85a1.jpeg";